/* template */
<template minapp="mpx" xlang="wxml"><mpx-view @tap="handleClick" :hover-class='(isLink ? "es-cell--hover" : "none")' :style="[({color: customStyle})] | transRpxStyle" class="es-cell" :class='[$attrs["custom-class"],(classnames)]'><es-icon :style="[(iconColorStyle)] | transRpxStyle" :name="(icon)" size="14" @click="clickLeftIcon" class="es-cell__left custom-left-icon" v-if="(icon)"></es-icon><slot name="icon" v-else></slot><div :style="[(width)] | transRpxStyle" class="es-cell__title custom-title" v-if="(title || useTitle)"><span v-if="(title)">{{title}}</span><slot name="title" v-else></slot><div class="es-cell__label custom-label" v-if="(label || useLabel)"><span v-if="(label)">{{ label }}</span><slot name="label" v-else/></div></div><div :style="[(styles)] | transRpxStyle" class="es-cell__value custom-value"><template v-if="(value || value === 0)">{{ value }}</template><slot v-else></slot></div><es-icon :name="(rightIcon)" size="14" class="es-cell__right custom-right-icon'" v-if="(isLink)"></es-icon><slot name="icon-right"></slot><slot name="extra"></slot></mpx-view></template>

/* styles */
<style lang="stylus" src="./style.styl" mpxStyleOptions='{"mid":"m1902b88c"}'>
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m1902b88c"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex1902b88c%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex1902b88c%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m1902b88c"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index1902b88c/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-icon':getComponent(require("../icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
